module.exports = __webpack_public_path__ + "static/video-search-0f0016e623294457aae39967c627d098.png";